import useSWR from 'swr';
import { getFullLanguage, getPatentDetail, getPearlFullLanguage } from '../services/api-patents';
import { countryToLanguageCode } from '@/helpers/constants';

async function fetchPatentData(ucid, isPearlApplication) {
  const patentDetailData = await getPatentDetail(ucid);

  const publicationNumber = patentDetailData && patentDetailData["_found"] ? patentDetailData["_source"].publication_number : null;

  if (!publicationNumber) {
    return undefined;
  }

  const fullLanguageData = await (isPearlApplication ? getPearlFullLanguage(publicationNumber) : getFullLanguage(publicationNumber));

  const flatData = patentDetailData["_source"];

  const defaultLanguage = countryToLanguageCode[flatData.country] || 'en';

  flatData.claims = fullLanguageData.claims;
  flatData.description = fullLanguageData.description.map(translation => {
    const joinedText = Object.values(translation.text).join('\n');
    return { ...translation, text: joinedText };
  });
  if (defaultLanguage !== 'en') {
    flatData.abstract = fullLanguageData.abstract.find(
      translation => translation.lang === defaultLanguage
    ).text;
  }
  flatData.translations = fullLanguageData.description;
  flatData.abstractTranslations = fullLanguageData.abstract;
  flatData.defaultLanguage = defaultLanguage;
  return flatData;
}

const usePatentData = (ucid, isPearlApplication = false) => {
  const { data, isValidating } = useSWR(
    ucid ? `patentData-${ucid}` : null,
    () => fetchPatentData(ucid, isPearlApplication),
    { revalidateOnFocus: false }
  );

  return {
    data,
    loading: isValidating,
  };
};

export default usePatentData;
